import React, { useEffect, useState } from "react";

import IndicatorLabel from "../../components/IndicatorLabel/IndicatorLabel";
import PackageCard from "../../components/CicleModal/PackageCard";

import indicatorsImg from "../../assets/images/INDICATORS.svg";
import biologicalImg from "../../assets/images/BIOLOGICO.svg";
import hygieneImg from "../../assets/images/HYGIENE MONITORING INDICATORS.svg";
import toStartIcon from "../../assets/images/Icono To start.svg";
import inProgressIcon from "../../assets/images/Icono In progress.svg";
import finishedIcon from "../../assets/images/Icono Finished.svg";
import { BsScissors } from "react-icons/bs";
import sterilizerIcon from "../../assets/images/greenSterilizer.svg";

import PersonIcon from "@material-ui/icons/Person";

import trazantoImg from "../../assets/images/QApp.png";

import t from "../../utils/translation";
import df from "../../utils/dateFormater";
import minutesToHourFormat from "../../utils/minutesToHours";
import request from "../../utils/request";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import styles from "./HygieneMonitoringDetail.module.css";

import { CiEdit, CiTimer, CiUser } from "react-icons/ci";
import { GoLink, GoUnlink } from "react-icons/go";
import { Tooltip } from "@material-ui/core";
import { IoBookOutline, IoReload } from "react-icons/io5";
import { TiDocumentText } from "react-icons/ti";
import { FaTemperatureHigh } from "react-icons/fa";
import PCDItemCycle from "../../components/PCDItemCycle/PCDItemCycle";
import ModalLoading from "../../components/ModalLoading/ModalLoading";
import hasPositive from "../../utils/hasPositive";
import Redirect from "../../utils/Redirect";
import washerIcon from "../../assets/images/purpleWashing.svg";
import materialImg from "../../components/NavBar/Menu/icons/INSTRUMENTS.svg";

const MySwal = withReactContent(Swal);

const HygieneMonitoringDetail = ({
  loadId,
  locale,
  handleIndicator,
  handleFormData,
  openEdit,
  handleLoadId,
  handleIsEdit,
  reloadDetail,
  handleReload,
  hygieneId,
}) => {
  const [hygieneDetail, setHygieneDetail] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [indicators, setIndicators] = useState({
    indicators: [],
    finishedIndicators: [],
    linkedIndicators: [],
    unlinkedIndicators: [],
    linkedIndicatorsCH: [],
    unlinkedIndicatorsCH: [],
  });

  const status = (value) => {
    return value === 2
      ? t("ToStartSpan", locale) || "To Start"
      : value === 3
      ? t("StartedSpan", locale) || "Started"
      : t("FinishedSpan", locale) || "Finished";
  };

  const findImg = (value) => {
    return value === 2
      ? toStartIcon
      : value === 3
      ? inProgressIcon
      : finishedIcon;
  };

  const getResultText = (result) => {
    switch (result) {
      case 1:
        return t("PositiveSpan");
      case 2:
        return t("NegativeSpan");
      case 3:
        return t("CanceledSpan");
      default:
        return "";
    }
  };

  const getResultCH = (result) => {
    switch (result) {
      case 3:
        return t("UnsafeSpan");
      case 4:
        return t("SafeSpan");
      default:
        return "";
    }
  };

  const getUserResultCH = (result) => {
    switch (result) {
      case 0:
        return t("AgreeSpan");
      case 1:
        return t("DisagreeSpan");
      default:
        return "";
    }
  };

  // const unlinkHandler = (id, isChemical) => {
  //   const url = isChemical ? "CHE_unlink" : "BI_Unlink";
  //   request()
  //     .put(`/api/Charge/${url}?chargeIndicatorId=${id}`)
  //     .then(() => getLoadId());
  // };

  const handleIndicators = (value) => {
    setIndicators(value);
  };

  // const unlinkConfirmation = (id, isChemical = false) => {
  //   MySwal.fire({
  //     title: "Are you sure you want to continue?",
  //     text: "Unlink.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Confirm",
  //     cancelButtonText: "Cancel",
  //     customClass: {
  //       confirmButton: "confirmButton",
  //       cancelButton: "cancelButton",
  //     },
  //     confirmButtonColor: "var(--primary-green)",
  //     cancelButtonColor: "var(--delete)",
  //     backgroundColor: "#f4f4f4",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       unlinkHandler(id, isChemical);
  //     }
  //   });
  // };

  const getLoadId = async () => {
    setModalLoading(true);
    try {
      await request()
        .get(`/api/hygiene/${hygieneId}`)
        .then((response) => {
          const data = response.data;
          setHygieneDetail(data);
          const indicators = [
            ...(data.indicators || []),
          ];
          handleIndicators({
            indicators: indicators,
          });
        });
    } catch {
    } finally {
      setModalLoading(false);
    }
  };

  const getResult = (statusDescription, result) => {
    if (statusDescription === "IN PROGRESS") {
      return "IN PROGRESS"; 
    }
  
    switch (result) {
      case 1:
        return "Negative";
      case 2:
        return "Cancelled";
      case 3:
        return "Positive";
      case 4:
        return "Negative without pencil";
      case 263:
        return "Pen not valid";
      case 770:
        return "Pen pulled out";
      case 10:
        return "Alert";
      case 11:
        return "Action";
      case 12:
        return "Associate area";
      default:
        return "";
    }
  };

  const handleDetail = (id) => {
    Redirect({
      redirect: true,
      path: `/appcyclewashdetail/${id}`,
      parameters: { hygieneRecord: true, hygieneId },
    });
  };


  useEffect(() => {
    getLoadId();
  }, []);

  // useEffect(() => {
  //   if (reloadDetail) {
  //     getLoadId();
  //     handleReload(false);
  //   }
  // }, [reloadDetail]);

  if (modalLoading) return <ModalLoading open={modalLoading} />;
  return (
    <div className={styles.container}>

<div className={styles.header}>
        <div className={styles.topHeader}>
          <div>
            <p className={styles.title}>
              
                <Tooltip
                  title={
                    <span>{` ${
                      hygieneDetail.hasPositive
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      hygieneDetail.indicators?.some(
                        (i) =>
                          i.readingPRO?.result === 3
                      )
                        ? styles.red
                        : hygieneDetail.indicators?.length === 0
                        ? styles.green  // Si no hay indicadores, verde
                        : hygieneDetail.indicators?.every((i) => i.readingPRO)
                        ? hygieneDetail.indicators?.some(
                            (i) =>
                              i.readingPRO?.result === 1
                          )
                          ? styles.green  // Si todos tienen reading/readingBI y cumplen la condición, verde
                          : styles.gray   // Si todos tienen reading/readingBI pero no cumplen la condición, gris
                        : styles.gray     // Si no todos tienen reading/readingBI, gris
                    }`}
                  ></div>
                </Tooltip>
              
              {hygieneDetail.packageNumber}
            </p>
          </div>
        
        </div>
        <div className={styles.headerDetails}>
            <div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyleHygiene} />
                <p className={styles.detailText}>
                  {t("StartedSpan") || "Started"}:{" "}
                  <span className={styles.info}>
                    {df(hygieneDetail.creationDate, "dateTime")}
                  </span>
                  {}
                </p>
              </div>
              {/* <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:{" "}
                  <span className={styles.info}>{hygieneDetail.creationUserName}</span>
                </p>
              </div> */}
            </div>

            {/* <div>
              <div className={styles.detailItem}>
                <BsScissors className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("MaterialSpan") || "Material"}:{" "}
                  <span className={styles.info}>{hygieneDetail.materials?.[0]?.material?.name}</span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <TiDocumentText className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("WasherSpan") || "Washer"}:{" "}
                  <span className={styles.info}>{hygieneDetail.usedProgram}</span>
                </p>
              </div>
            </div> */}
             <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyleHygiene} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:{" "}
                  <span className={styles.info}>{hygieneDetail.creationUserName}</span>
                </p>
              </div>
            <div>
            </div>
          </div>
      </div>
  
      <div className={styles.header}>
          <div className={styles.headerTitleContainer}>
            <p
              className={styles.title}
              onClick={() => handleDetail(hygieneDetail.chargeWashingId)}
            >
              <Tooltip
                  title={
                    <span>{` ${
                      hygieneDetail.chargeWashing?.hasPositive
                        ? t("BlankEntry18")
                        : t("BlankEntry19")
                    }`}</span>
                  }
                  arrow
                >
                  <div
                    className={`${styles.hasPositive} ${
                      hygieneDetail.relatedChargeHasPositive                      
                        ? styles.red
                        : (hygieneDetail.relatedChargeVinculatedIndicators?.length !== 0 && !(hygieneDetail.relatedChargeHasPositive))
                        ? styles.green
                        : styles.gray
                    }`}
                  ></div>
                </Tooltip>
               {`${t("CycleNumberSpan", locale) || "Cycle Number"}: ${
                hygieneDetail.relatedCicleNumber ?? ""
              }`}
            </p>
            <div className={styles.detailItem}>
              <div className={styles.detailItem} style={{ gap: "10px" }}>
                <img
                  className={styles.iconImg}
                  alt={status(hygieneDetail.chargeStatus)}
                  src={findImg(hygieneDetail.chargeStatus)}
                />
                <span className={styles.infoStatus}>
                  {status(hygieneDetail.chargeStatus)}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.sterilizerContainerInfo}>
            <img
              className={styles.iconSterilizer}
              src={washerIcon}
              alt="washer icon"
            />
            <p className={styles.sectionSubTitle}>
              {hygieneDetail.washer?.name} - {hygieneDetail.washerMethod}
            </p>
          </div>
          <div className={styles.headerDetails}>
            <div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("StartedSpan") || "Started"}:{" "}
                  <span className={styles.info}>
                    {df(hygieneDetail.chargeWashing?.cicleStartDate, "dateTime")}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoReload className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("FinishedSpan") || "Finished"}:{" "}
                  <span className={styles.info}>
                    {df(hygieneDetail.chargeWashing?.cicleFinishDate, "dateTime")}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <PersonIcon className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("OperatorSpan") || "User"}:{" "}
                  <span className={styles.info}>{hygieneDetail.chargeWashing?.creationUser}</span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <TiDocumentText className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("UsedProgramSpan") || "Used Program"}:{" "}
                  <span className={styles.info}>{hygieneDetail.chargeWashing?.usedProgram}</span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <FaTemperatureHigh className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TemperatureSpan") || "Temperature"}:{" "}
                  <span className={styles.info}>
                    {hygieneDetail.chargeWashing?.temperature &&
                      hygieneDetail.chargeWashing?.temperature +
                        " " +
                        hygieneDetail.chargeWashing?.temperatureUnit}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <CiTimer className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("TimeSpan") || "Time"}:{" "}
                  <span className={styles.info}>
                    {hygieneDetail.chargeWashing?.washingTime &&
                      hygieneDetail.chargeWashing?.washingTime + " " + hygieneDetail.chargeWashing?.timeUnit}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("DetergentTypeSpan", locale) || "Detergent Type"}:{" "}
                  <span className={styles.info}>
                    {hygieneDetail.detergentTypeDescription}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("DetergentConcentrationSpan", locale) ||
                    "Detergent Concentration"}
                  :{" "}
                  <span className={styles.info}>
                    {hygieneDetail.chargeWashing?.detergentConcentration}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("WaterPressureSpan", locale) || "Water Pressure"}:{" "}
                  <span className={styles.info}>
                    {hygieneDetail.chargeWashing?.waterPressure}
                  </span>
                </p>
              </div>
              <div className={styles.detailItem}>
                <IoBookOutline className={styles.iconStyle} />
                <p className={styles.detailText}>
                  {t("WaterHardnessSpan", locale) || "Water Hardness"}:{" "}
                  <span className={styles.info}>
                    {hygieneDetail.chargeWashing?.waterHardness}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className={styles.observationSection2}>
            <p className={`${styles.observationTitle2}`}>
              {t("ObservationSpan")}
            </p>
            {hygieneDetail.chargeWashing?.observations && (
              <div className={styles.observationContainer2}>
                <p className={styles.observation2}>
                  {hygieneDetail.chargeWashing?.observations}
                </p>
              </div>
            )}
          </div>
        </div>
     
  <section className={styles.section}>
          <div className={styles.imageTitleContainer}>
            <img src={hygieneImg} alt="Indicators" className={styles.image} />
            <h2 className={styles.sectionTitle}>{"Protein indicators"}</h2>
          </div>

          {hygieneDetail.indicators && hygieneDetail.indicators.length === 0 ? (
            <p className={styles.noDataMessage}>{t("NoIndicatorsSpan")}.</p>
          ) : (
            <div
              className={styles.indicatorMaterialContainer} 
            >
              {/* Indicators Section */}
              <div
                className={styles.indicatorSection}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "20px",
                  }}
                >
                  {hygieneDetail.indicators?.map((indicator) => (
                    <div className={styles.indicatorItem} key={indicator.indicatorId}>
                      <IndicatorLabel
                        backgroundColor={"white"}
                        name={indicator.indicator.name}
                        lot={indicator.lot}
                        serial={indicator.serial}
                        expirationDate={hygieneDetail.indicatorExpirationDate}
                        border={true}
                        tubeResultPro={indicator.readingPRO?.result}
                        statusDescription={indicator.readingPRO?.statusDescription}
                      />

                      <div className={styles.detailsBox}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        ></div>

                        {hygieneDetail.readingPRO === null? (
                          <span>{t("WithoutReadingSpan")}</span>
                        ) : (
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span>
                              {t("ReadingNumber") || "Record number"}:{" "}
                              {hygieneDetail.readingPRO?.readNumber}
                            </span>
                            <span>
                              {t("Position") || "Position"}:{" "}
                              {hygieneDetail.readingPRO?.positionNumber}
                            </span>
                            <span>
                              {t("Nro ticket") || "Nro ticket"}:{" "}
                              {hygieneDetail.readingPRO?.ticketNumber}
                            </span>
                            <span>
                              {t("StartDateSpan") || "Start Date"}:{" "}
                              {df(hygieneDetail.readingPRO?.startedTime, "dateTime")}
                            </span>
                            <span>
                              {t("FinishDateSpan") || "Finish Date"}:{" "}
                              {df(hygieneDetail.readingPRO?.resultDate, "dateTime")}
                            </span>
                            <span>
                              {t("Result") || "Result"}:{" "}
                              {getResult(hygieneDetail.readingPRO?.statusDescription,hygieneDetail.readingPRO?.result)}
                            </span>
                            <span>
                              {t("averageTemperature") || "Average temperature"}:{" "}
                              {hygieneDetail.readingPRO?.averageTemperatureProFormat}
                            </span>
                          <span>
                            {t("incubator") || "Incubator"}:{" "}
                            {hygieneDetail.readingPRO?.incubator.name}{" "}
                            0{hygieneDetail.readingPRO?.incubator.serialNumber}{" "}
                            {hygieneDetail.readingPRO?.incubator.lote}
                          </span>
                             <span>
                              {t("CuantitativeResultLabel", locale) || "Protein Level"}:{" "}
                              {hygieneDetail.readingPRO?.cuantitativeResultFormat}
                            </span>
                            <span>
                              {t("ObservationSpan") || "Observations"}:{" "}
                              {hygieneDetail.readingPRO?.notes} 
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Materials Section */}
              <div
                className={styles.materialsSection}
              >
          <div className={styles.imageTitleContainerMaterial}>
            <img src={materialImg} alt="Material" className={styles.image} />
            <h2 className={styles.sectionTitle}>{"Material"}</h2>
          </div>
                {hygieneDetail.materials?.map((material) => (
                  <div className={styles.materialCard} key={material.material.id}>
                    <div className={styles.cardHeader}>
                      {material.material.name || "Material"}
                    </div>
                    <div className={styles.columnsContainer}>
                      <div className={styles.columnsCard}>
                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>Type:</span>
                          <span className={styles.fieldValue}>
                            {material.material.materialType.name}
                          </span>
                        </div>

                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>Serial:</span>
                          <span className={styles.fieldValue}>
                            {material.material.serial || "N/A"}
                          </span>
                        </div>

                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>Cycles:</span>
                          <span className={styles.fieldValue}>
                            {material.material.cyclesWarning}
                          </span>
                        </div>
                      </div>
                      <div className={styles.columnsCard}>
                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>Implant:</span>
                          <span className={styles.fieldValue}>
                            {material.material.isImplant ? "Yes" : "No"}
                          </span>
                        </div>

                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>Endoscopy:</span>
                          <span className={styles.fieldValue}>
                            {material.material.isEndoscopy ? "Yes" : "No"}
                          </span>
                        </div>

                        <div className={styles.fieldRow}>
                          <span className={styles.fieldLabel}>
                            Compatible Method:
                          </span>
                          <span className={styles.fieldValue}>
                            {hygieneDetail.compatibleMethod}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
  </section>
    </div>
  );
};

export default HygieneMonitoringDetail;
